import { z } from "zod";

import { excludeBasicFields } from "./excludeBasicFields";
import {
  makeNullableFieldsOptional,
  OptionalizedNullableFields,
} from "./makeNullableFieldsOptional";

export const makeCreateInputSchema = <T extends z.ZodObject<z.ZodRawShape>>(
  schema: T,
): z.ZodObject<OptionalizedNullableFields<Omit<T["shape"], "id" | "createdAt" | "updatedAt">>> => {
  const cleanedSchema = excludeBasicFields(schema);

  return makeNullableFieldsOptional(cleanedSchema);
};
